export const enumPermisosRecaudoMultiple = Object.freeze({
  pago_recaudo_multiple: 26000,
  consulta_recaudo_multiple: 26001,
  consulta_paginada_recaudo_multiple: 26002,
  pago_recaudo_multiple_comercio: 26003,
});
